import { render, staticRenderFns } from "./Documente.vue?vue&type=template&id=0d1c8ab1&scoped=true&"
import script from "./Documente.ts?vue&type=script&lang=ts&"
export * from "./Documente.ts?vue&type=script&lang=ts&"
import style0 from "./Documente.vue?vue&type=style&index=0&id=0d1c8ab1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c8ab1",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
